module.exports = "/_next/static/images/logo-6f675de755f0abd10a92b9374c22f1c0.svg";